import React, { useState, useEffect, memo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'
import {
  WebRounded as PanelIcon,
  CloseRounded as CloseIcon,
  LaunchRounded as LaunchIcon,
} from '@material-ui/icons'
import RemoveRoundedIcon from '@material-ui/icons/RemoveRounded'

import { setUsability } from '../../../redux/usability/actions'

import Alert from '../../molecules/feedback/dialogs/alert'
import IconButton from '../../atoms/inputs/iconButton'
import Tooltip from '../../atoms/display/tooltip'
import Icon from '../../atoms/display/icon'

import useStyles from './usabilityStyle'

const Usability = ({setUsabilityList, ...props}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const classes = useStyles()
  const theme = useTheme()
  const timeOut = useRef(null)

  const activeConversation = useSelector((state) => state.activeConversation)
  const undock = useSelector((state) => state.undock)
  const conversations = undock.data
    ? undock.conversations
    : useSelector((state) => state.conversations)
  const conversation = conversations.conversations[activeConversation]

  const [loading, setLoading] = useState(true)
  const [openCloseModal, setOpenCloseModal] = useState(false)

  const deleteNode = () => {
    conversation.relatedComponents.usability.url = null
    setOpenCloseModal(false)
    dispatch(setUsability(Date.now()))
  }

  const minimizeUsability = () => {
    conversation.relatedComponents.usability.isOpen = false
    dispatch(setUsability(Date.now()))
  }

  const openWindow = () => {
    window.open(props?.src)
    deleteNode()
  }

  const renderCloseModal = () => {
    return (
      openCloseModal && (
        <Alert
          title={t('commons.closeUsability')}
          text={t('alerts.closeUsabilityQuestion')}
          open={setOpenCloseModal}
          agreeAction={() => deleteNode()}
        />
      )
    )
  }

  function unMount() {
    setUsabilityList((prev) => ({
      ...prev,
      [props?.chatId]: {},
    }))
  }

  useEffect(() => setLoading(true), [props?.src])

  useEffect(() => {
    if (props?.isOpen) {
      if (timeOut.current) {
        clearTimeout(timeOut.current)
      }
    } else {
      timeOut.current = setTimeout(() => {
        unMount()
      }, (30 * 1000 * 60))
      return () => {
        clearTimeout(timeOut.current)
      }
    }
  }, [props?.isOpen])

  return (
    <>
      <div
        className={`${classes.root} ${
          props?.isOpen ? classes.visible : classes.hidden
        }`}
      >
        <div className={classes.header}>
          <Icon text={t('commons.usability')}>
            <PanelIcon />
          </Icon>
          <div style={{ display: 'flex' }}>
            <Tooltip placement="bottom" title={t('commons.minimize')}>
              <div>
                <IconButton color="primary" onClick={() => minimizeUsability()}>
                  <RemoveRoundedIcon className={classes.headerIcon} />
                </IconButton>
              </div>
            </Tooltip>
            <div style={{ width: 10 }} />
            <Tooltip placement="bottom" title={t('buttons.launch')}>
              <div>
                <IconButton color="primary" onClick={() => openWindow()}>
                  <LaunchIcon className={classes.headerIcon} />
                </IconButton>
              </div>
            </Tooltip>
            <div style={{ width: 10 }} />
            <Tooltip placement="bottom" title={t('commons.close')}>
              <div>
                <IconButton
                  color="primary"
                  onClick={() => setOpenCloseModal((prev) => !prev)}
                >
                  <CloseIcon className={classes.headerIcon} />
                </IconButton>
              </div>
            </Tooltip>
          </div>
        </div>
        <div className={classes.content}>
          {loading && (
            <div className={classes.loading}>
              <CircularProgress size={50} />
            </div>
          )}
          <iframe
            src={props?.src}
            frameBorder="0"
            onLoad={() => setLoading(false)}
          ></iframe>
        </div>
        {renderCloseModal()}
      </div>
    </>
  )
}

export default memo(Usability)
